<div class="row">
    <div class="col-md-6">
        <div class="card bg-light">
            <div class="card-header bg-warning">
                <h3>Pending email approval [{{pending_email_users.length}}]</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive table-striped">
                        <p-table #dt1 [value]="pending_email_users" [resizableColumns]="true" [autoLayout]="true" [tableStyle]="{ 'text-align': 'center' }" sortMode="multiple">
                            <ng-template pTemplate="header">
                                <th pSortableColumn="uid">UID <p-sortIcon field="uid"></p-sortIcon></th>
                                <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
                                <th pSortableColumn="duration">Duration <p-sortIcon field="duration"></p-sortIcon></th>
                                <th pSortableColumn="registration">Registration <p-sortIcon field="registration"></p-sortIcon></th>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                            <tr>
                                <td><a routerLink="/user/{{user.uid}}"><span class="p-button p-button-sm p-button-warning">{{user.uid}}</span></a></td>
                                <td>{{user.email}}</td>
                                <td>{{user.duration}}</td>
                                <td>{{user.registration | date}}</td>
                            </tr>
                            </ng-template>
                        </p-table>
                </div>


            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card bg-light">
            <div class="card-header bg-warning">
                <h3>Pending admin approval [{{pending_approval_users.length}}]</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive table-striped">
                        <p-table #dt2 [value]="pending_approval_users" [resizableColumns]="true" [autoLayout]="true">
                            <ng-template pTemplate="header">
                                <th pSortableColumn="uid">UID <p-sortIcon field="uid"></p-sortIcon></th>
                                <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
                                <th pSortableColumn="duration">Duration <p-sortIcon field="duration"></p-sortIcon></th>
                                <th pSortableColumn="registration">Registration <p-sortIcon field="registration"></p-sortIcon></th>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                            <tr>
                                <td><a routerLink="/user/{{user.uid}}"><span class="p-button p-button-sm p-button-warning">{{user.uid}}</span></a></td>
                                <td>{{user.email}}</td>
                                <td>{{user.duration}}</td>
                                <td>{{user.registration | date}}</td>
                            </tr>
                            </ng-template>
                        </p-table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="card bg-light">
        <div class="card-header">
            <h3>Active [{{active_users.length}}]</h3>
        </div>
        <div class="card-body">
             <div class="table-responsive table-striped">
                        <p-table #dt3 [value]="active_users" [resizableColumns]="true" [autoLayout]="true"
                                    [paginator]="true"
                                    [rows]="10"
                                    [showCurrentPageReport]="true"
                                    [rowsPerPageOptions]="[10,25,50]"
                                    [globalFilterFields]="['name', 'uid', 'email', 'uidnumber', 'why', 'firstname', 'lastname']"
                                    [filterDelay]="0"
                        >
                        <ng-template pTemplate="caption">
                            <div class="table-header">
                                <span class="p-input-icon-right">
                                    <i class="pi pi-search"></i>
                                    <input pInputText id="search_active_users" type="text" (input)="dt3.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
                                </span>
                            </div>
                        </ng-template>
                            <ng-template pTemplate="header">
                                <th pSortableColumn="uid">UID <p-sortIcon field="uid"></p-sortIcon></th>
                                <th pSortableColumn="uidnumber">Uid number <p-sortIcon field="uidnumber"></p-sortIcon></th>
                                <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
                                <th pSortableColumn="expiration">Expiration <p-sortIcon field="expiration"></p-sortIcon></th>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                            <tr>
                                <td><a routerLink="/user/{{user.uid}}"><span class="p-button p-button-sm">{{user.uid}}</span></a></td>
                                <td>{{user.uidnumber}}</td>
                                <td>{{user.email}}</td>
                                <td>{{user.expiration | date}}</td>
                            </tr>
                            </ng-template>
                        </p-table>
                </div>
        </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="card bg-light">
        <div class="card-header bg-danger">
            <h3>Expired [{{expired_users.length}}]</h3>
        </div>
        <div class="card-body">
             <div class="table-responsive table-striped">
                        <p-table #dt4 [value]="expired_users" [resizableColumns]="true" [autoLayout]="true"
                                    [paginator]="true"
                                    [rows]="10"
                                    [showCurrentPageReport]="true"
                                    [rowsPerPageOptions]="[10,25,50]"
                                    [globalFilterFields]="['name', 'uid', 'email', 'uidnumber']"
                                    [filterDelay]="0"
                        >
                        <ng-template pTemplate="caption">
                            <div class="table-header">
                                <span class="p-input-icon-right">
                                    <i class="pi pi-search"></i>
                                    <input pInputText id="search_expired_users" type="text" (input)="dt4.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
                                </span>
                            </div>
                        </ng-template>
                            <ng-template pTemplate="header">
                                <th pSortableColumn="uid">UID <p-sortIcon field="uid"></p-sortIcon></th>
                                <th pSortableColumn="uidnumber">Uid number <p-sortIcon field="uidnumber"></p-sortIcon></th>
                                <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
                                <th pSortableColumn="expiration">Expiration <p-sortIcon field="expiration"></p-sortIcon></th>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                            <tr>
                                <td><a routerLink="/user/{{user.uid}}"><span class="p-button p-button-sm p-button-danger">{{user.uid}}</span></a></td>
                                <td>{{user.uidnumber}}</td>
                                <td>{{user.email}}</td>
                                <td>{{user.expiration | date}}</td>
                            </tr>
                            </ng-template>
                        </p-table>
                </div>
        </div>
    </div>
  </div>
</div>
